module.exports = __webpack_public_path__ + "img/value.8256ba1b.svg";